module.exports = __webpack_public_path__ + "media/images/check-green-74015ec4.svg";